/**
 * The search params each pathname was last shown with, for the session. A
 * parent crumb restores them so going "back" up the trail keeps the filters,
 * page and selection the user had when they navigated down.
 */
const searchByPathname = new Map<string, Record<string, unknown>>();

function key(pathname: string): string {
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

/** Remember `search` for `pathname`; an empty search forgets it. */
export function rememberCrumbSearch(
  pathname: string,
  search: Record<string, unknown>,
): void {
  if (Object.keys(search).length === 0) {
    searchByPathname.delete(key(pathname));
    return;
  }
  searchByPathname.set(key(pathname), search);
}

export function recallCrumbSearch(
  pathname: string,
): Record<string, unknown> | undefined {
  return searchByPathname.get(key(pathname));
}

export function clearCrumbSearchMemory(): void {
  searchByPathname.clear();
}
